<div cdkDrag cdkDragRootElement=".cdk-overlay-pane" class="mat-typography crud-editor-div crud-editor-dialog">
  <h2 mat-dialog-title cdkDragHandle>Failed login</h2>
  <mat-dialog-content>
    <div class="crud-item-page">
      <p>Login Failed.</p>
      <div *ngIf="isCodeInvalid">
        <p>SSO Authorisation 'Code' Invalid: </p>
        <p>These errors are flagged as possible security incidents.</p>
        <ul>
          <li>The SSO code appears as a long character string at the end of the address in your browser. <br/>It is generated by your SSO login each time you log in, and cannot be used more than once, and is only valid for a short time.</li>
          <li>Using an eAssets bookmark/favourite address ending with <b>'/login?code='</b> followed by a long character string can cause this error.</li>
          <li>Please check your bookmark is exactly: <b>https://eassets.forestryengland.uk</b></li>
          <li>Refreshing the page or duplicating the tab while this long code character string is present in the address can also cause this.
          </li>
        </ul>
        <p>Click the 'Login' button to try again.</p>
      </div>
      <div *ngIf="lockedForDurationMillis != null">
        <p>Login attempts for this username has been temporarily suspended due to repeated login failures.</p>
        <p>While it is suspended, further attempts will extend the suspension period.</p>
        <p>Your temporary suspension will be lifted in: {{lockedUntilDurationDisplay}} <span
            *ngIf="lockedForDurationMillis < 0">(Suspension no longer in effect)</span></p>
      </div>
      <div *ngIf="!isCodeInvalid && lockedForDurationMillis == null">
        <ul>
          <li>If you are a new eAssets user, logging in for the first time, this is expected: Your account may not have
            been set up yet. Administrators will have been notified, so that they can complete your account setup.</li>
          <li>If this is not your first time logging in, there may be problem with your account:
            Contact Forestry England National Operations Team (<a
              href="mailto:operationsadmin@forestryengland.uk">operationsadmin@forestryengland.uk</a>) to resolve
            access.
          </li>
          <li>Further attempts to login while this issue exists, will cause your account to be temporarily suspended.
          </li>
        </ul>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="crud-edit-dialog-actions-container">
      <div class="crud-edit-actions">
        <button mat-raised-button color="primary" (click)="close()" i18n="@@actions.ok">Ok</button>
      </div>
    </div>
  </mat-dialog-actions>
</div>
